module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.c8a5544.woff";